<template>
  <div class="account">
    <div class="main-content">
      <div class="account-list-container">
        <div class="section-header text-center mobile-hide">
          <h2>{{ $t('billManagement') }}</h2>
        </div>
      
        <div class="section-header balanceTitle">
          <h3>{{ $t('accountBalance') }}</h3>
        </div> 
        <div class="balanceInfo">
          <div>
            <span>{{ $t('balance') }}: </span>
            <span class="balance">${{balance}}</span>
          </div>
          <div>
            <p class="btn" @click="openDepositModal()">
              {{ $t('depositOnline') }}
            </p>
          </div>
        </div> 
        
        <div class="section-header balanceTitle" >
          <h3>{{ $t('transaction') }}</h3>
        </div> 
        <div class="filters-toolbar-wrapper">
          <div>
            <div style="display: inline-block; width: 60%;">
              <p style="margin-left: 10px">{{ $t('orderTime') }}</p>
              <el-date-picker
                v-model="date"
                type="daterange"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                style="width:100%"
                @change="updateDate"
              />
            </div>
            <div style="display: inline-block; width: 20%;">
              <p style="margin-left: 10px">{{ $t('perPage') }}</p>
              <el-select v-model="limit" v-bind:placeholder="$t('limit')" value="" @change="updateLimit">
                <el-option
                  v-for="item in limitOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <button 
              class="btn"
              @click="exportBalance()"
            >
              <span>{{ $t("export") }}</span>
            </button>
          </div>
          <div>
            <div style="display: inline-block; width: 60%;">
              <p style="margin-left: 10px">{{ $t('search') }}</p>
              <el-input
                v-model="searchValue"
                v-bind:placeholder="$t('search')"
              ></el-input>
            </div>
            <div style="display: inline-block; width: 20%;">
              <p style="margin-left: 10px">{{ $t('searchType') }}</p>
              <el-select v-model="searchType" v-bind:placeholder="$t('searchType')" value="">
                <el-option
                  v-for="item in searchTypeOptions"
                  :key="item.value"
                  :label="$t(item.label)"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <button class="btn" @click="updateFilter()">
              <span>{{ $t("search") }}</span>
            </button>
          </div>
        </div>
        <table class="responsive-table">
          <thead>
            <tr>
              <th>{{ $t('date') }}</th>
              <th>{{ $t('orderNo') }}</th>
              <th>{{ $t('trackingNo') }}</th>
              <th>{{ $t('deposit') }}</th>
              <th>{{ $t('withdraw') }}</th>
              <th>{{ $t('balance') }}</th>
              <th>{{ $t('description') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in this.$store.state.auth.balanceList" data-index="index" :key="index" class="responsive-table__row">
              <td data-label="date">{{moment(item.create_time).format('MMM D, YYYY h:mm A')}}</td>
              <td data-label="sales_order">{{ item.sales_order }}</td>
              <td data-label="trackingNo"></td>
              <td data-label="amount" v-if="item.amount > 0">${{ item.amount }}</td>
              <td data-label="amount" v-else></td>
              <td data-label="amount" v-if="item.amount < 0">${{ item.amount }}</td>
              <td data-label="amount" v-else></td>
              <td data-label="post_balance">${{ item.post_balance }}</td>
              <td data-label="note">{{ item.note }}</td>
            </tr>
          </tbody>
        </table>
        <pagination
          :totalPages="pages"
          :total="count"
          :currentPage="currentPage"
          @pagechanged="onPageChange"
        />
      </div>
    </div>
    <el-dialog
      v-bind:title="$t('submitCardInfo')"
      :visible.sync="depositVisible"
      @close="closeDepositModal()"
      class="modal"
    >
      <el-form ref="cardForm" :model="cardForm">
        <div class="fieldset">
          <div class="field">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item v-bind:label="$t('amount')">
                  <el-input-number
                    v-model="cardForm.amount"
                    :min="0"
                    :controls="false"></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="12">
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item v-bind:label="$t('cardHolderName')">
                  <el-input v-model="cardForm.name" type="name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-bind:label="$t('creditCardNumber')">
                  <el-input v-model="cardForm.card_num" type="card_num" @input="cardNumberFormatter(cardForm.card_num)"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item v-bind:label="$t('cardExpiration')">
                  <el-input
                    v-model="cardForm.exp_date"
                    type="exp_date"
                    @input="cardExpireDateFormatter(cardForm.exp_date)"
                    :maxlength="5">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item v-bind:label="$t('CVC')">
                  <el-input v-model="cardForm.cvv" type="cvv" :maxlength="4"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="end">
          <!-- <span v-show="cardError" style="color:red">{{cardError}}</span> -->
          <button
            :disabled="!this.cardForm.amount || !this.cardForm.card_num || !this.cardForm.exp_date || !this.cardForm.cvv"
            style="marginTop: 30px"
            class="btn"
            @click="submitDeposit(cardForm, $event)"
          >
            {{ $t("submit") }}
          </button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapState, mapMutations } from 'vuex';
import pagination from "../../components/pagination";

export default {
  name: "paymentList",
  components: {
    pagination,
  },
  data() {
    return {
      moment: moment,
      path2: this.$t('billManagement'),
      cardError: [],
      currentPage: 1,
      date: '',
      start_date: '',
      end_date: '',

      limit: '15',
      limitOptions: [
        { value: '15', label: '15' },
        { value: '30', label: '30' },
        { value: '50', label: '50' },
        { value: '100', label: '100'},
      ],
      
      searchValue: '',
      searchType: 'sonum',
      searchTypeOptions: [
        { value: 'sonum', label: 'orderNo' },
        { value: 'trans_id', label: 'trackingNo' },
        { value: 'note', label: 'note' },
      ],
      
      depositVisible: false,
      cardForm: {
        amount: null,
        card_num: null,
        exp_date: null,
        cvv: null,
      },
    }
  },
  methods: {
    ...mapActions('auth', ['fetchCustomerBalance']),
    updateDate(value) {
      this.start_date = moment(value[0]).format();
      this.end_date = moment(value[1]).format();
      this.updateFilter();
    },
    updateLimit(value) {
      this.limit = value;
      this.updateFilter();
    },
    updateFilter() {
      const page = this.currentPage || 1;
      let limit = ''
      if (this.limit) {
        limit = this.limit;
      }
      this.$store.dispatch('auth/fetchCustomerBalance', 
      [this.$store.state.auth.userDetails.Customer_id, limit, page,
        this.start_date, this.end_date, this.searchValue, this.searchType, false]);
    },
    exportBalance() {
      let start = '';
      let end = '';
      let search = '';
      let ex = '';
      
      const token = localStorage.getItem('token');
      
      if (this.searchValue && this.searchType) {
        search = `&${searchType}=${searchValue}`;
      }
      
      if (this.start_date && this.end_date) {
        start = `&start_date=${start_date}`;
        end = `&end_date=${end_date}`;
      }
      
      // this.$store.dispatch('auth/fetchCustomerBalance', [
      //   this.$store.state.auth.userDetails.Customer_id, this.limit, 1,
      //   this.start_date, this.end_date, this.searchValue, this.searchType, true]);
      // 
      const url = `https://ying-scm.truckxi.com/api/v1/customer/balance/${this.$store.state.auth.userDetails.Customer_id}?limit=${this.limit}&page=1${start}${end}${search}&export=true&JWT=${token}`;
      window.location.href = url;
    },
    onPageChange(page) {
      this.currentPage = page;
      this.updateFilter();
      window.scrollTo(0, 0);
    },
    resetForm() {
      this.cardForm = {
        amount: null,
        card_num: null,
        exp_date: null,
        cvv: null,
      }
    },
    cardNumberFormatter(value) {
      var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
      var matches = v.match(/\d{4,19}/g);
      var match = matches && matches[0] || '';
      var parts = [];

      for (var i=0, len=match.length; i<len; i+=4) {
        parts.push(match.substring(i, i+4))
      }
      if (parts.length) {
        this.cardForm.card_num = parts.join(' ');
      } else {
        this.cardForm.card_num = value;
      }
    },
    cardExpireDateFormatter(date) {
      if (date.length == 3) {
        if (date[date.length - 1] !== '/') {
          var temp =  this.cardForm.exp_date.split('');
          temp.splice(2, 0, '/');
          this.cardForm.exp_date = temp.join('');
          return;
        }else {
          this.cardForm.exp_date = this.cardForm.exp_date.slice(0, 2);
        }
      }
    },
    openDepositModal() {
      this.depositVisible = true;
      this.cardForm= {
        amount: null,
        card_num: null,
        exp_date: null,
        cvv: null,
      }
    },
    closeDepositModal(event) {
      event.preventDefault();
      this.$refs['cardForm'].resetForm();
      this.depositVisible = false;
    },
    submitDeposit(cardInfo, event) {
      this.cardError = []
      event.preventDefault();
      
      let depositInfo = {};
      depositInfo.amount = this.cardForm.amount;
      depositInfo.card_num = this.cardForm.card_num.split(' ').join('')
      depositInfo.exp_date = this.cardForm.exp_date;
      depositInfo.cvv = this.cardForm.cvv;
       
      // if (!this.cardError.length) {
        this.$store.dispatch("auth/postBalance", [depositInfo, this.$store.state.auth.userDetails.Customer_id]).then(() => {
          this.resetForm();
          this.depositVisible = false;
          this.$store.dispatch('auth/fetchCustomerBalance', [
            this.$store.state.auth.userDetails.Customer_id, this.limit, 1,
            this.start_date, this.end_date, this.searchValue, this.searchType, false]);
        });
      // } else {
      //   alert(this.cardError);
      // }
    },
  },
  computed: mapState({
    balance: state => state.auth.balance,
    pages: state => state.auth.balanceListPaginate,
    count: state => state.auth.balanceListCount,
    userDetails: state => state.auth.userDetails,
  }),
  mounted() {
    this.$store.dispatch('auth/fetchCustomerBalance', [
      this.$store.state.auth.userDetails.Customer_id, this.limit, 1,
      this.start_date, this.end_date, , this.searchValue, this.searchType, false]);
  },
}
</script>

<style scoped lang="less">
@import "../../assets/css/accountList.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/paymentList.vue